const runtimeConfig =
  (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) || {};

const parseRuntimeBoolean = value =>
  value === true || String(value).toLowerCase() === 'true';

const config = {
  debug: true, // stage -> true and prod -> false
  cryptography: false,
  development: true,
  //=============Production==========================================================
  segmentWriteKey: '5pfhNbBi1ECrXJyGgCKx2Am8AW7KUSAg',
  endpoint: runtimeConfig.API_URL || 'https://api.juratinc.com',
  googleApiKey: runtimeConfig.GOOGLE_API_KEY || '',
  intercomSecretKey: runtimeConfig.INTERCOM_SECRET_KEY || '',
  notaryGptEnabled: parseRuntimeBoolean(runtimeConfig.NOTARYGPT_ENABLED),
  notaryGptPortalUrl: runtimeConfig.NOTARYGPT_PORTAL_URL || '',
  appRedirectEndpont: 'app-jurat://app.juratinc.com',

  //=============Staging==========================================================
  // segmentWriteKey: 'XBXwuQhWXXZQ63z51UVPOpcPfYc9TPT3', //Fake
  // endpoint: runtimeConfig.API_URL || 'http://api.staging.juratinc.com:9001',
  // appRedirectEndpont: 'app-jurat://v2.staging.juratinc.com',

  // //=============Dev==========================================================
  // segmentWriteKey: 'XBXwuQhWXXZQ63z51UVPOpcPfYc9TPT3', //Fake
  // endpoint: runtimeConfig.API_URL || 'https://devapi.juratinc.com',
  // appRedirectEndpont: 'app-jurat://v2.dev.juratinc.com',

  //=======================================================================
  //-----------------------------App Settings------------------------------
  //=======================================================================
  allowQrCodeInReports: false,
  generateReportOnServer: true
};

export default config;
